import PageContainer from "@/components/PageContainer";
import FeedCalculator from "@/components/FeedCalculator";

export default function BiayaPakanPage() {
  return (
    <PageContainer
      title="Biaya Pakan"
      subtitle="Hitung estimasi biaya pakan harian & bulanan berdasarkan harga bahan"
    >
      <FeedCalculator withCost={true} />
    </PageContainer>
  );
}
